import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TopBar from 'elements/TopBar/TopBar';
import BasicAccordion from 'elements/BasicAccordion';
import BasicAccordionPdf from 'elements/BasicAccordionPdf';
import { ProjectConfig } from 'Global';
import { getMartyrologyDesignationLabel, getSantoralLabel } from 'hooks/useLabels';

export default function MartyrologyViewer(props: any) {
  const { entry_id } = useParams();
  const langId = localStorage.getItem('lang_id') || '1';
  const [entry, setEntry] = useState<any>(null);
  const [content, setContent] = useState<any>(null);

  useEffect(() => {
    let active = true;
    setEntry(null);
    setContent(null);
    props.setLoading(true);

    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'martyrology_details',
        lang_id: langId,
        id: entry_id,
      },
      timeout: 15000,
    })
      .then((response) => {
        if (active) {
          setEntry(response.data.entry || null);
          setContent(response.data.content || null);
        }
      })
      .catch(() => {
        if (active) {
          setEntry(null);
          setContent(null);
        }
      })
      .finally(() => { if (active) props.setLoading(false); });
    return () => { active = false; };
  }, [entry_id, langId]);

  return (
    <div id="MartyrologyViewer" className="module_container">
      <div className="module_topBar">
        <TopBar title={getSantoralLabel('martirologio_romano')} />
      </div>

      <div className="module_content">
        {entry ? (
          <div className="CardContents">
            {entry.image && <img src={entry.image} alt={entry.name} style={{ display: 'block', maxWidth: '100%', width: 280, maxHeight: 360, objectFit: 'contain', margin: '0 auto 20px' }} />}
            <h1>{entry.name}</h1>
            {entry.month && entry.day && (
              <p>
                <strong>{getSantoralLabel('fecha')}:</strong>{' '}
                {String(entry.day).padStart(2, '0')}/{String(entry.month).padStart(2, '0')}
              </p>
            )}
            {entry.designation && <p><strong>{getSantoralLabel('condicion')}:</strong> {getMartyrologyDesignationLabel(entry.designation)}</p>}
            {entry.place && <p><strong>{getSantoralLabel('lugar')}:</strong> {entry.place}</p>}
            {entry.period && <p><strong>{getSantoralLabel('epoca')}:</strong> {entry.period}</p>}
            {entry.source_reference && <p><strong>{getSantoralLabel('fuente')}:</strong> {entry.source_reference}</p>}
            {content?.biography_html && <BasicAccordion titulo={getSantoralLabel('biografia')} contenido={content.biography_html} />}
            {content?.prayers_html && <BasicAccordion titulo={getSantoralLabel('oraciones_del_santo')} contenido={content.prayers_html} />}
            {content?.calendar_html && <BasicAccordion titulo={getSantoralLabel('calendario_propio_hsf')} contenido={content.calendar_html} />}
            {(content?.files || []).map((file: any, index: number) => <BasicAccordionPdf key={`${file.file_id}-${index}`} titulo={file.name} filePdf={file.file} />)}
            {content?.lectionary_html && <BasicAccordion titulo={getSantoralLabel('lecturas')} contenido={content.lectionary_html} />}
            {['primeras_visperas', 'oficio_lectura', 'laudes', 'horas_intermedias', 'visperas', 'completas'].map((hour) => (
              content?.hours?.[hour] ? <BasicAccordion key={hour} titulo={getSantoralLabel(hour)} contenido={content.hours[hour]} /> : null
            ))}
          </div>
        ) : (
          <div className="CardContents">
            <p>{getSantoralLabel('sin_resultados')}</p>
          </div>
        )}
      </div>
    </div>
  );
}

